import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import {
  Table,
  Form,
  Button,
  Pagination,
  Modal,
  Spinner,
} from "react-bootstrap";

import { BsEye } from "react-icons/bs";
import { getURLbyEndPoint } from "../../../store/api";
import { jsPDF } from "jspdf";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import membCertSmall from "../../../assets/membershipCertTemplate/membershipCertSmallBuissness.jpg";
import membCertCorp from "../../../assets/membershipCertTemplate/membershipCertCoporate.jpg";
import membCertCorpplus from "../../../assets/membershipCertTemplate/membershipCertCoporate+.jpg";
import { formatDate } from "../profilePages/ClientSuperAdmin";
import axios from "axios";
import Logo from "../../../assets/footerlogo1.png";
import { numberToWords } from "../../../components/basic/simpleFunctions";

const MembershipServices = () => {
  const navigate = useNavigate();
  const [membRenewReq, setMembRenewReq] = useState([]);
  const [reqStatus, setReqStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Invoice modal state
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoicePdfUrl, setInvoicePdfUrl] = useState(null);
  const [invoiceDataId, setInvoiceDataId] = useState(null);
  const [invoiceSaved, setInvoiceSaved] = useState(false);
  const [invoicePdfBlob, setInvoicePdfBlob] = useState(null);
  const [approvingInvoice, setApprovingInvoice] = useState(false);

  const filteredData = membRenewReq.filter((data) => {
    // Filter based on account status
    if (reqStatus !== "" && data.isApproved !== reqStatus) {
      return false;
    }
    // Filter based on app NO
    if (
      searchTerm !== "" &&
      !data.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    ) {
      return false;
    }
    return true;
  });

  const handleInputChange = (e, userId, field) => {
    const updatedData = membRenewReq.map((item) =>
      item._id === userId ? { ...item, [field]: e.target.value } : item,
    );

    setMembRenewReq(updatedData);
    console.log(membRenewReq);
  };

  //updating membership here
  const handleUpdateRejectMemb = async (userId, status) => {
    const apiData = membRenewReq.find((item) => item._id === userId);

    if (!apiData.membershipCertificate) {
      alert("Membership Certificate is required.");
      return;
    }

    const validationRules = {
      membershipCertificate: {
        message: "Please upload a valid PDF file below 5 MB.",
        isValid: () => {
          const isPdf =
            apiData.membershipCertificate.type === "application/pdf";
          const isSizeValid =
            apiData.membershipCertificate.size <= 5 * 1024 * 1024;
          return isPdf && isSizeValid;
        },
      },
      newMemberShipNo: {
        message: "Please enter Membership No.",
        isValid: () =>
          apiData.newMemberShipNo && apiData.newMemberShipNo.length <= 20,
      },
      validUpto: {
        message: "Please enter valid upto field.",
        isValid: () =>
          apiData.validUpto !== null && apiData.validUpto !== undefined,
      },
      remark: {
        message: "Please enter remark.",
        isValid: () => apiData.remark && apiData.remark.length <= 75,
      },
    };

    for (const field in validationRules) {
      const { message, isValid } = validationRules[field];
      if (!isValid()) {
        alert(message);
        return;
      }
    }

    const formData = new FormData();
    formData.append("status", status);
    formData.append("membershipCertificate", apiData.membershipCertificate);
    formData.append("newMemberShipNo", apiData.newMemberShipNo);
    formData.append("validUpto", apiData.validUpto);
    formData.append("remark", apiData.remark);

    try {
      console.log("data is here", formData.get("status"));
      const res = await axios.put(
        getURLbyEndPoint("updateRejectMembRenew") + userId,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data.status) {
        window.location.reload();
        alert(res.data.message);
      }

      if (res.data.errorCode === "insufficientBalance") {
        alert("User don't have sufficient balance");
      }
    } catch (error) {
      alert("Internal Server Error");
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(getURLbyEndPoint("getMembRenewReq"));
      if (response.status === 200) {
        const data = response.data;

        // Extracting properties from each object in the array
        const updatedData = data.data.map((item) => {
          const { membershipCertificate, newMemberShipNo, validUpto, remark } =
            item;

          // Returning an object with the extracted variables
          return {
            ...item,
            membershipCertificate: null,
            newMemberShipNo,
            validUpto,
            remark,
          };
        });

        console.log("Extracted Data:", updatedData);

        setMembRenewReq([...updatedData]);
      } else {
        console.error("Failed to fetch registered users data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
    console.log(membRenewReq);
  }, []);

  const handleGenerateMembership = (userId) => {
    const updatedClientData = membRenewReq.find((user) => user._id === userId);

    // --------------------------------adding validation for fields--------------------------------------------------------------
    if (!updatedClientData) {
      alert("User not found");
      return;
    }
    if (!updatedClientData.newMemberShipNo) {
      alert("Please enter membership number");
      return;
    }
    if (!updatedClientData.validUpto) {
      alert("Please valid upto");
      return;
    }

    const membershipCertImage = {
      "Small Business (Associate)": membCertSmall,
      Corporate: membCertCorp,
      "Corporate +": membCertCorpplus,
    };

    const selectedMembership = updatedClientData.selectMembership;
    const imgSource = membershipCertImage[selectedMembership];

    if (!imgSource) {
      console.error(`Invalid membership type: ${selectedMembership}`);
      alert("Invalid membership type");
      return;
    }

    const pdf = new jsPDF({
      unit: "mm",
      format: "a4",
      orientation: "portrait",
    });

    // Set background image
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(imgSource, "JPEG", 0, 0, imgWidth, imgHeight);

    pdf.setTextColor("#5d3e35");
    pdf.setFontSize(20);
    pdf.setFont("Eczar", "bold");
    const text = updatedClientData.companyName;
    const textWidth = pdf.getTextWidth(text);
    // Get the document width and calculate the center position
    const documentWidth = pdf.internal.pageSize.getWidth();
    const centerX = (documentWidth - textWidth) / 2;
    // Set the text position to the calculated center
    pdf.text(centerX, 150, text);

    //setting membership no. width
    pdf.setFontSize(16);
    pdf.setFont("Roboto", "bold");
    const membNo = updatedClientData.newMemberShipNo;
    const membNoTextWidth = pdf.getTextWidth(membNo); // Measure text width
    const membNoCenterX = 70 - membNoTextWidth / 2; // Calculate center X
    pdf.text(membNoCenterX, 200, membNo);

    // Usage example
    // const validUpto = "31st March 2026";
    const validUpto = updatedClientData.validUpto;
    const formattedDate = formatDate(validUpto);

    const validUptoTextWidth = pdf.getTextWidth(formattedDate); // Measure text width
    const validUptoCenterX = 132 - validUptoTextWidth / 2; // Calculate center X
    pdf.text(validUptoCenterX, 200, formattedDate);

    // Generate the PDF blob
    const blobPdf = pdf.output("blob", { encoding: "raw" });

    // Create a URL from the blob
    // const url = URL.createObjectURL(blobPdf);

    // Open the PDF in a new window or tab
    //  window.open(url, '_blank');

    //seeting like this so state will update

    setMembRenewReq((prevClientData) =>
      prevClientData.map((user) =>
        user._id === userId
          ? {
              ...user,
              membershipCertificate: new Blob([blobPdf], {
                type: "application/pdf",
              }),
            }
          : user,
      ),
    );
  };

  // Helper: build invoice PDF and return { blob, url }
  const generateInvoicePdf = (data, receiptNo) => {
    const approvalDate = new Date(data.updatedAt);
    const formattedDate = `${approvalDate.getDate()}-${new Intl.DateTimeFormat(
      "en-US",
      { month: "short" },
    ).format(approvalDate)}-${approvalDate.getFullYear()}`;
    const formattedTime = approvalDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const xOfImg = (pageWidth - 25) / 2;
    pdf.addImage(Logo, "PNG", xOfImg, 8, 25, 25);

    pdf.setFontSize(20);
    pdf.text("Asian Exporters' Chamber of Commerce And Industry", 22, 45);
    pdf.setFontSize(12);
    pdf.text(
      "Regd Office: 604, 6th Floor, Hilton Centre, Plot No.66, Sector-11, CBD Belapur, Navi Mumbai,",
      20,
      52,
    );
    pdf.text("Maharashtra, E-mail: info@aecci.org.in", 68, 56);

    pdf.setFontSize(20);
    pdf.text("INVOICE CUM RECEIPT", 64, 74);
    pdf.line(15, 78, 195, 78);

    pdf.setFontSize(10);

    // Right column metadata
    pdf.text(`Date: ${formattedDate}`, 145, 94);
    pdf.text(`Time: ${formattedTime}`, 145, 99);
    pdf.text(`AECCI Code: ${data.memberShipNo || ""}`, 145, 104);
    if (data.gstNo) {
      pdf.text(`GSTIN: ${data.gstNo}`, 145, 109);
    }

    // Left column metadata
    pdf.text(`Receipt No: ${receiptNo}`, 15, 94);

    pdf.text("Received From:", 15, 99);
    const companyLines = pdf.splitTextToSize(data.companyName || "", 95);
    companyLines.forEach((line, index) => {
      pdf.text(line, 42, 99 + index * 5);
    });

    let nextY = 99 + (companyLines.length > 0 ? companyLines.length * 5 : 5);

    pdf.text("Address:", 15, nextY);
    const address = (data.address1 || "") + " " + (data.address2 || "");
    const addressLines = pdf.splitTextToSize(address.trim(), 95);
    addressLines.forEach((line, index) => {
      pdf.text(line, 32, nextY + index * 5);
    });

    nextY += addressLines.length > 0 ? addressLines.length * 5 : 5;
    let metaBottomY = Math.max(nextY, 114);

    pdf.line(15, metaBottomY, 195, metaBottomY);

    const headers = ["Sr no.", "Particulars", "Quantity", "Rate", "Amount"];
    const baseAmount = data.amount || 0;
    let finalTotalAmount = baseAmount;

    const tableData = [
      [
        "1",
        `Membership Renewal - ${data.selectMembership} (${data.noOfYears} Year${data.noOfYears > 1 ? "s" : ""})`,
        "1",
        `Rs. ${baseAmount}/-`,
        `Rs. ${baseAmount}/-`,
      ],
    ];

    if (data.remark && data.remark.toLowerCase().includes("razorpay")) {
      const convFee = baseAmount * 0.02;
      const gstOnFee = Math.round(convFee * 0.18);
      const roundedConvFee = Math.round(convFee);
      finalTotalAmount = baseAmount + roundedConvFee + gstOnFee;

      tableData.push([
        "2",
        "Convenience Fee",
        "-",
        "-",
        `Rs. ${roundedConvFee + gstOnFee}/-`,
      ]);
    }

    const startY = metaBottomY + 5;
    const lineHeight = 10;
    const columnWidths = [15, 85, 25, 25, 30];
    const startX = 15;

    let currentX = startX;
    headers.forEach((header, index) => {
      if (index >= 2) {
        // Right align headers for Quantity, Rate, Amount
        pdf.text(header, currentX + columnWidths[index], startY, {
          align: "right",
        });
      } else {
        pdf.text(header, currentX, startY);
      }
      currentX += columnWidths[index];
    });
    pdf.line(startX, startY + 5, 195, startY + 5);

    tableData.forEach((row, rowIndex) => {
      currentX = startX;
      const yPos = startY + lineHeight * (rowIndex + 1);
      row.forEach((cell, cellIndex) => {
        if (cellIndex === 1) {
          const cellLines = pdf.splitTextToSize(
            cell,
            columnWidths[cellIndex] - 2,
          );
          cellLines.forEach((line, lineIdx) => {
            pdf.text(line, currentX, yPos + lineIdx * 4);
          });
        } else if (cellIndex >= 2) {
          // Right align values for Quantity, Rate, Amount
          pdf.text(cell, currentX + columnWidths[cellIndex], yPos, {
            align: "right",
          });
        } else {
          pdf.text(cell, currentX, yPos);
        }
        currentX += columnWidths[cellIndex];
      });
      pdf.line(startX, yPos + 5, 195, yPos + 5);
    });

    pdf.text("Total:", 15, startY + lineHeight * (tableData.length + 1));
    pdf.text(
      `Rs. ${finalTotalAmount}/-`,
      180,
      startY + lineHeight * (tableData.length + 1),
      { align: "right" },
    );
    pdf.line(
      15,
      5 + startY + lineHeight * (tableData.length + 1),
      195,
      5 + startY + lineHeight * (tableData.length + 1),
    );

    pdf.text(
      `Amount In words(in INR): ${numberToWords(finalTotalAmount)}`,
      15,
      startY + lineHeight * (tableData.length + 2),
    );
    pdf.line(
      15,
      5 + startY + lineHeight * (tableData.length + 2),
      195,
      5 + startY + lineHeight * (tableData.length + 2),
    );

    pdf.text(
      "For Asian Exporters' Chamber of Commerce and Industry",
      195,
      10 + startY + lineHeight * (tableData.length + 2),
      { align: "right" },
    );
    pdf.text(
      "Authorised Signatory",
      195,
      20 + startY + lineHeight * (tableData.length + 2),
      { align: "right" },
    );
    pdf.text(
      "Note: This is system generated invoice, no signature required.",
      15,
      20 + startY + lineHeight * (tableData.length + 2),
    );

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    return { pdfBlob, pdfUrl };
  };

  // Generate Invoice locally - show in modal with Approve button
  const handleGenerateInvoice = (userId) => {
    const data = membRenewReq.find((item) => item._id === userId);
    if (!data) {
      alert("Data not found");
      return;
    }

    // Use a placeholder receipt no - will be replaced when approved
    const { pdfBlob, pdfUrl } = generateInvoicePdf(data, "PENDING");
    setInvoicePdfBlob(pdfBlob);
    setInvoicePdfUrl(pdfUrl);
    setInvoiceDataId(userId);
    setInvoiceSaved(false);
    setShowInvoiceModal(true);
  };

  // Approve: send PDF to backend, get receipt no, save to S3
  const handleApproveInvoice = async () => {
    const data = membRenewReq.find((item) => item._id === invoiceDataId);
    if (!data) {
      alert("Data not found");
      return;
    }

    setApprovingInvoice(true);
    try {
      // 1. Fetch real receipt number from backend (increments counter)
      const resReceipt = await axios.get(getURLbyEndPoint("getMembReceiptNo"));
      if (!resReceipt.data.status) {
        alert("Failed to generate receipt number");
        return;
      }
      const receiptNo = resReceipt.data.receiptNo;

      // 2. Re-generate PDF with actual receipt number
      const { pdfBlob: finalBlob, pdfUrl: finalUrl } = generateInvoicePdf(
        data,
        receiptNo,
      );

      // 3. Upload the final PDF with correct receipt no
      const formData = new FormData();
      formData.append("invoiceFile", finalBlob, "invoice.pdf");
      formData.append("receiptNo", receiptNo);

      const resSave = await axios.post(
        getURLbyEndPoint("saveMembInvoice") + invoiceDataId,
        formData,
      );

      if (!resSave.data.status) {
        alert(resSave.data.message || "Failed to save invoice");
        return;
      }

      const receiptFileUrl = resSave.data.receiptFile;

      // Revoke old "PENDING" URL
      if (invoicePdfUrl && !invoiceSaved) URL.revokeObjectURL(invoicePdfUrl);

      // Update local membRenewReq state
      setMembRenewReq((prev) =>
        prev.map((item) =>
          item._id === invoiceDataId
            ? { ...item, receiptNo, receiptFile: receiptFileUrl }
            : item,
        ),
      );

      setInvoicePdfUrl(finalUrl);
      setInvoicePdfBlob(finalBlob);
      setInvoiceSaved(true);
      alert("Invoice approved and saved successfully!");
    } catch (error) {
      console.error("Error saving invoice:", error);
      alert("Failed to save invoice. Please try again.");
    } finally {
      setApprovingInvoice(false);
    }
  };

  // View saved invoice from S3 URL
  const handleViewInvoice = (userId) => {
    const data = membRenewReq.find((item) => item._id === userId);
    if (!data || !data.receiptFile) {
      alert("No receipt found");
      return;
    }

    setInvoiceDataId(userId);
    setInvoicePdfUrl(data.receiptFile);
    setInvoicePdfBlob(null);
    setInvoiceSaved(true);
    setShowInvoiceModal(true);
  };

  // Pagination logic
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Assuming items per page is fixed

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFiltered = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Calculate the range of pages to display
  const calculateRange = (currentPage, totalPages) => {
    let startPage = Math.max(1, currentPage - 5);
    let endPage = Math.min(totalPages, currentPage + 4); // Adjusted to show 10 pages

    // Adjust if the range is too close to the beginning or end
    if (endPage - startPage < 9) {
      if (startPage === 1) {
        endPage = Math.min(10, totalPages);
      } else if (endPage === totalPages) {
        startPage = Math.max(totalPages - 9, 1);
      }
    }

    return { startPage, endPage };
  };

  const { startPage, endPage } = calculateRange(currentPage, totalPages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    window.scrollTo(0, 100);
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    window.scrollTo(0, 100);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  return (
    <>
      <Layout>
        <div className="d-flex justify-content-center align-items-start">
          <div className="py-1 align-items-center justify-content-center main-width">
            <hr />
            <DashboardHeader
              heading="Services/ Membership Service"
              backUrl="/master-services"
            />
            <hr />
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex gap-3">
                <Form.Check
                  inline
                  label="All"
                  name="group1"
                  type="radio"
                  defaultChecked
                  checked={reqStatus === ""}
                  onChange={() => setReqStatus("")}
                />
                <Form.Check
                  inline
                  label="Processing"
                  name="group1"
                  type="radio"
                  defaultChecked
                  checked={reqStatus === "Processing"}
                  onChange={() => setReqStatus("Processing")}
                />{" "}
                <Form.Check
                  inline
                  label="UPDATED"
                  name="group1"
                  type="radio"
                  defaultChecked
                  checked={reqStatus === "Updated"}
                  onChange={() => setReqStatus("Updated")}
                />{" "}
                <Form.Check
                  inline
                  label="REJECTED"
                  name="group1"
                  type="radio"
                  defaultChecked
                  checked={reqStatus === "Rejected"}
                  onChange={() => setReqStatus("Rejected")}
                />{" "}
              </div>
              <div className="d-flex align-items-center gap-2">
                <input
                  className="form-control"
                  style={{ width: "250px" }}
                  type="search"
                  placeholder="Search By company Name"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button
                  variant="primary"
                  onClick={() => navigate("/master-membership-renewal-mails")}
                >
                  Membership Renewal mails
                </Button>
              </div>
            </div>
            {Array.isArray(membRenewReq) && membRenewReq.length > 0 ? (
              <Table responsive striped bordered hover className="text-center">
                <thead>
                  <tr>
                    <th className="align-middle">SR NO.</th>
                    <th className="align-middle">Company Details</th>
                    <th className="align-middle">Transaction Details</th>
                    <th className="align-middle">Membership Update</th>
                    <th className="align-middle">Invoice</th>
                    <th className="align-middle">Action</th>
                  </tr>
                </thead>

                {currentFiltered.length > 0 ? (
                  <>
                    {currentFiltered.map((data, index) => (
                      <tbody className="text-center">
                        <tr key={index}>
                          <th className="text-start">
                            {filteredData.length - indexOfFirstItem - index}.{" "}
                            <div className="max-content">
                              Created at:
                              <br />
                              <span className="text-success">
                                {new Intl.DateTimeFormat("en-GB", {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                  hour: "numeric",
                                  minute: "numeric",
                                }).format(new Date(data.createdAt))}
                              </span>
                            </div>
                          </th>
                          <td>
                            <div className="text-start max-content">
                              <h6>
                                Company Name :{" "}
                                <span className="text-secondary">
                                  {" "}
                                  {data.companyName}
                                </span>
                              </h6>
                              <h6>
                                Membership No. :{" "}
                                <span className="text-secondary">
                                  {data.memberShipNo}
                                </span>
                              </h6>
                              <h6>
                                Membership Type. :{" "}
                                <span className="text-secondary">
                                  {data.selectMembership}
                                </span>
                              </h6>
                            </div>
                          </td>
                          <td>
                            <div className="text-start max-content">
                              {data.utrNo && (
                                <h6>
                                  Utr No.:{" "}
                                  <span className="text-secondary">
                                    {data.utrNo}
                                  </span>
                                </h6>
                              )}
                              <h6>
                                Amount:{" "}
                                <span className="text-secondary">
                                  {data.amount}
                                </span>
                              </h6>
                              <h6>
                                Year:{" "}
                                <span className="text-secondary">
                                  {data.noOfYears}
                                </span>
                              </h6>

                              {data.paymentScreenShot && (
                                <h6>
                                  <a
                                    href={data.paymentScreenShot}
                                    target="_blank"
                                  >
                                    Payment ScreenShot
                                  </a>{" "}
                                </h6>
                              )}
                            </div>
                          </td>

                          <td>
                            <div className="d-flex w-100 justify-content-evenly">
                              {data.isApproved == "Processing" ? (
                                <div>
                                  <Form.Control
                                    type="text"
                                    className="mb-2"
                                    maxLength={20}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        data._id,
                                        "newMemberShipNo",
                                      )
                                    }
                                    placeholder="Membership Number"
                                    name="memberShipNo"
                                    value={data.newMemberShipNo}
                                    style={{ display: "block" }}
                                  />
                                  <Form.Control
                                    type="date"
                                    name="validUpto"
                                    value={data.validUpto}
                                    className="mb-2"
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        data._id,
                                        "validUpto",
                                      )
                                    }
                                  />
                                  {/* <div>
                                      <Button
                                        variant={
                                          data.membershipCertificate
                                            ? "success"
                                            : "primary"
                                        }
                                        className="py-2 mb-2 border-none w-100 fw-semibold"
                                        onClick={() => {
                                          document.getElementById(
                                            "fileInput"
                                          ).dataset.userId = data._id;
                                          document
                                            .getElementById("fileInput")
                                            .click();
                                        }}
                                      >
                                        {data.membershipCertificate
                                          ? "Uploaded"
                                          : "Upload Certificate"}
                                      </Button>
                                      <Form.Control
                                        type="file"
                                        accept=".pdf"
                                        onChange={(e) => {
                                          handleFileChange(e);
                                        }}
                                        id="fileInput"
                                        style={{ display: "none" }}
                                      />
                                    </div> */}
                                  <div>
                                    {data.selectMembership !==
                                      "Digital User" && (
                                      <Button
                                        variant={
                                          data.membershipCertificate
                                            ? "success"
                                            : "primary"
                                        }
                                        onClick={() =>
                                          handleGenerateMembership(data._id)
                                        }
                                      >
                                        Generate Certificate
                                      </Button>
                                    )}{" "}
                                    {data.membershipCertificate && (
                                      <a
                                        href={URL.createObjectURL(
                                          data.membershipCertificate,
                                        )}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <BsEye className="icon-size" />
                                      </a>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-start max-content">
                                  <h6>
                                    Membership No. :{" "}
                                    <span className="text-secondary">
                                      {data.memberShipNo}
                                    </span>
                                  </h6>
                                </div>
                              )}
                            </div>

                            {/* <div className="max-content">
                          Updated at:
                          <br />
                          <span className="text-success">
                            {new Intl.DateTimeFormat("en-GB", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                            }).format(new Date(data.updatedAt))}
                          </span>
                        </div> */}
                          </td>
                          <td>
                            <div className="text-center">
                              {data.isApproved === "Updated" ? (
                                data.receiptFile ? (
                                  <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => handleViewInvoice(data._id)}
                                  >
                                    Invoice
                                  </Button>
                                ) : (
                                  <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() =>
                                      handleGenerateInvoice(data._id)
                                    }
                                  >
                                    Generate Invoice
                                  </Button>
                                )
                              ) : (
                                <Button variant="secondary" size="sm" disabled>
                                  Generate Invoice
                                </Button>
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="text-center">
                              {data.isApproved === "Processing" && (
                                <div className="max-content">
                                  <Form.Control
                                    as="textarea"
                                    rows={1}
                                    placeholder="Enter a Remark"
                                    onChange={(e) =>
                                      handleInputChange(e, data._id, "remark")
                                    }
                                    value={data.remark}
                                    rows={2}
                                    name="remark"
                                    maxLength={75}
                                  />{" "}
                                </div>
                              )}

                              {data.remark &&
                              data.isApproved === "Processing" ? (
                                <div className="d-flex justify-content-evenly mt-3">
                                  <AiFillCheckCircle
                                    className="icon-size green-color cursor-pointer"
                                    onClick={() =>
                                      handleUpdateRejectMemb(data._id, true)
                                    }
                                  />
                                  <AiFillCloseCircle
                                    className="icon-size text-danger cursor-pointer"
                                    onClick={() =>
                                      handleUpdateRejectMemb(data._id, false)
                                    }
                                  />
                                </div>
                              ) : null}
                            </div>
                            {data.isApproved !== "Processing" && (
                              <h6>
                                Remark :{" "}
                                <span className="text-secondary">
                                  {" "}
                                  {data.remark}
                                </span>
                              </h6>
                            )}

                            {data.isApproved == "Updated" && (
                              <div className="max-content fw-bold align-top">
                                Updated at:
                                <br />
                                <span className="text-success">
                                  {new Intl.DateTimeFormat("en-GB", {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                  }).format(new Date(data.updatedAt))}
                                </span>
                              </div>
                            )}
                            {data.isApproved == "Rejected" && (
                              <div className="max-content fw-bold">
                                Rejected at:
                                <br />
                                <span className="text-danger">
                                  {new Intl.DateTimeFormat("en-GB", {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                  }).format(new Date(data.updatedAt))}
                                </span>
                              </div>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={6} className="text-center">
                        No Matching Data
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            ) : (
              <p>No data available</p>
            )}

            {totalPages > 1 && (
              <div className="d-flex justify-content-start mt-2">
                <Pagination>
                  <Pagination.Prev
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                  />
                  {Array.from(
                    { length: endPage - startPage + 1 },
                    (_, index) => (
                      <Pagination.Item
                        key={index + startPage}
                        active={index + startPage === currentPage}
                        onClick={() => handlePageChange(index + startPage)}
                      >
                        {index + startPage}
                      </Pagination.Item>
                    ),
                  )}
                  <Pagination.Next
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              </div>
            )}
          </div>
        </div>

        {/* Invoice PDF Preview Modal */}
        <Modal
          show={showInvoiceModal}
          onHide={() => {
            setShowInvoiceModal(false);
            if (invoicePdfUrl && !invoiceSaved) {
              URL.revokeObjectURL(invoicePdfUrl);
            }
            setInvoicePdfUrl(null);
            setInvoiceDataId(null);
            setInvoicePdfBlob(null);
          }}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Invoice Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {invoicePdfUrl ? (
              <iframe
                src={invoicePdfUrl}
                width="100%"
                height="500px"
                title="Invoice Preview"
                style={{ border: "none" }}
              />
            ) : (
              <p className="text-center">Generating invoice...</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowInvoiceModal(false);
                if (invoicePdfUrl && !invoiceSaved) {
                  URL.revokeObjectURL(invoicePdfUrl);
                }
                setInvoicePdfUrl(null);
                setInvoiceDataId(null);
                setInvoicePdfBlob(null);
              }}
            >
              Close
            </Button>
            {!invoiceSaved ? (
              <Button
                variant="success"
                onClick={handleApproveInvoice}
                disabled={approvingInvoice}
              >
                {approvingInvoice ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />{" "}
                    Approving...
                  </>
                ) : (
                  "Approve"
                )}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  if (invoicePdfUrl) {
                    window.open(invoicePdfUrl, "_blank");
                  }
                }}
              >
                Download
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </Layout>
    </>
  );
};

export default MembershipServices;
